import { DATE_FORMAT, TIME_FORMAT } from "constants"
import { dateTimeFunction } from "utils/date"
import Icon from "../icon/icon"
import Tooltip from "../tooltip/tooltip"
import { useSelector } from "react-redux"
const DateFormat = ({
  dateClassName = "gray-800",
  date: d,
  showTime,
  dateFormat = DATE_FORMAT,
  color = "red",
  icon = "BiCalendar",
  customTooltip,
  showTimeWithTooltip = true,
  iconProps,
  dateColor,
}) => {
  const timezone = useSelector(
    (state) => state?.app?.user?.tenantInfo?.tenant?.configuration?.timezone
  );

  let date = dateTimeFunction({ date: d, format: dateFormat, tenantTimezone: timezone })
  let time = dateTimeFunction({ date: d, format: TIME_FORMAT, tenantTimezone: timezone })

  const tooltipTitle = `${customTooltip ? customTooltip : ""} ${date}${
    showTimeWithTooltip ? `, ${time}` : ""
  }`

  return (
    d && (
      <div
        className={dateClassName}
        style={{ cursor: !!showTime ? "default" : "pointer" }}
      >
        <Tooltip title={tooltipTitle}>
          {icon && <Icon icon={icon} size="14px" {...iconProps}/>}
          {icon && " "}
          {<span style={{ color: dateColor }}>{date}</span>}
          {showTime && <span style={{ color: color }}>&nbsp; {time}</span>}
        </Tooltip>
      </div>
    )
  )
}

export default DateFormat
